class ShopifyAddonsPopup {
  constructor() {

    this.TAG_MAP = {
      "residential-under-sink-filters": ['residential filter addons'],

      "corporate-under-sink-filter": ['corporate filter addons'],

      "horeca-under-sink-filters": ['horeca filter addons'],
      "scale-inhibitor-filter-ice-machines": ['horeca filter addons'],
      "water-softener-filter-coffee-machines": ['horeca filter addons'],
    };

    this.allProducts = [];
    this.popup = null;
    this.currentProduct = null;
    this.quantities = {};
    this.cartItems = {};
    this.init();
  }

  init() {
    // Add CSS styles
    this.addStyles();

    // Fetch cart items on load
    this.fetchCartItems();

    // Intercept all "Add to Cart" buttons
    this.interceptAddToCart();

    //load all products
    this.fetchAllProducts();
  }

  async fetchAllProducts() {
    if (this.allProducts.length) return this.allProducts;

    const response = await fetch('/products.json?limit=250');
    const data = await response.json();

    this.allProducts = data.products || [];
    return this.allProducts;
  }


  addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .addons-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: fadeIn 0.2s ease-out;
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      .addons-popup {
        background: white;
        border-radius: 12px;
        max-width: 1100px;
        width: 100%;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        animation: slideUp 0.3s ease-out;
      }

      @keyframes slideUp {
        from { 
          transform: translateY(30px);
          opacity: 0;
        }
        to { 
          transform: translateY(0);
          opacity: 1;
        }
      }

      .addons-header {
        padding: 24px 32px;
        border-bottom: 1px solid #e5e7eb;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .addons-header h2 {
        font-size: 24px;
        font-weight: 700;
        margin: 0;
      }

      .addons-close {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #6b7280;
        padding: 0;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: color 0.2s;
      }

      .addons-close:hover {
        color: #374151;
      }

      .addons-content {
        flex: 1;
        overflow-y: auto;
        padding: 32px;
      }

      .addons-section-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        font-weight: 600;
        font-size: 14px;
        text-transform: uppercase;
        color: #374151;
      }

      .main-product-card {
        background: #f9fafb;
        border-radius: 8px;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;
      }

      .product-info {
        display: flex;
        gap: 16px;
        align-items: center;
        flex: 1;
      }

      .product-image {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
        background: white;
        border: 1px solid #e5e7eb;
      }

      .product-details h4 {
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: 600;
      }

      .product-price {
        color: #6b7280;
        font-size: 14px;
        margin: 4px 0;
      }

      .product-category {
        color: #9ca3af;
        font-size: 13px;
      }

      .quantity-controls {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .qty-btn {
        width: 36px;
        height: 36px;
        border: 1px solid #d1d5db;
        background: white;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        transition: all 0.2s;
      }

      .qty-btn:hover {
        background: #f3f4f6;
        border-color: #9ca3af;
      }

      .qty-btn:active {
        transform: scale(0.95);
      }

      .qty-input {
        width: 60px;
        text-align: center;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        padding: 8px;
        font-size: 14px;
      }

      .product-total {
        font-weight: 700;
        font-size: 18px;
        min-width: 120px;
        text-align: right;
      }

      .addons-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 24px;
      }

      .addons-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
      }

      @media (max-width: 768px) {
        .addons-grid {
          grid-template-columns: 1fr;
        }
        
        .addons-header {
          padding: 16px 20px;
        }
        
        .addons-content {
          padding: 20px;
        }
        
        .addons-footer {
          padding: 16px 20px;
        }
        
        .footer-actions {
          flex-direction: column;
          gap: 16px;
        }
        
        .action-buttons {
          width: 100%;
        }
        
        .btn {
          width: 100%;
        }
      }

      .addon-card {
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        padding: 16px;
        display: flex;
        gap: 16px;
        transition: all 0.2s;
      }

      .addon-card.selected {
        border-color: #06b6d4;
        background: #ecfeff;
      }

      .addon-checkbox {
        width: 24px;
        height: 24px;
        border: 2px solid #d1d5db;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-top: 4px;
        transition: all 0.2s;
      }

      .addon-checkbox:hover {
        border-color: #06b6d4;
      }

      .addon-checkbox.checked {
        background: #06b6d4;
        border-color: #06b6d4;
        color: white;
      }

      .addon-image {
        width: 60px;
        height: 60px;
        object-fit: cover;
        border-radius: 6px;
        background: white;
        border: 1px solid #e5e7eb;
        flex-shrink: 0;
      }

      .addon-details {
        flex: 1;
      }

      .addon-name {
        font-weight: 600;
        font-size: 15px;
        margin: 0 0 4px 0;
      }

      .addon-price {
        color: #06b6d4;
        font-weight: 600;
        font-size: 14px;
        margin: 4px 0;
      }

      .addon-meta {
        font-size: 13px;
        color: #6b7280;
        margin: 2px 0;
      }

      .addon-quantity {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: auto;
      }

      .addon-qty-btn {
        width: 32px;
        height: 32px;
        border: 1px solid #d1d5db;
        background: white;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
      }

      .addon-qty-btn:hover {
        background: #f3f4f6;
        border-color: #9ca3af;
      }

      .addon-qty-input {
        width: 50px;
        text-align: center;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        padding: 6px;
        font-size: 14px;
      }

      .addons-footer {
        border-top: 1px solid #e5e7eb;
        padding: 24px 32px;
        background: #f9fafb;
      }

      .terms-checkbox {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;
      }

      .checkbox-control {
        width: 24px;
        height: 24px;
        border: 2px solid #d1d5db;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
      }

      .checkbox-control:hover {
        border-color: #06b6d4;
      }

      .checkbox-control.checked {
        background: #06b6d4;
        border-color: #06b6d4;
        color: white;
      }

      .terms-text {
        font-size: 14px;
        color: #374151;
      }

      .terms-link {
        color: #06b6d4;
        text-decoration: underline;
      }

      .footer-actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .total-section p {
        margin: 0;
        font-size: 13px;
        color: #6b7280;
      }

      .total-amount {
        font-size: 28px;
        font-weight: 700;
        margin: 4px 0 0 0;
      }

      .action-buttons {
        display: flex;
        gap: 16px;
      }

      .btn {
        padding: 14px 32px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 15px;
        cursor: pointer;
        transition: all 0.2s;
      }

      .btn:active {
        transform: scale(0.98);
      }

      .btn-secondary {
        background: white;
        border: 2px solid #06b6d4;
        color: #06b6d4;
      }

      .btn-secondary:hover {
        background: #ecfeff;
      }

      .btn-primary {
        background: #06b6d4;
        border: 2px solid #06b6d4;
        color: white;
      }

      .btn-primary:hover {
        background: #0891b2;
        border-color: #0891b2;
      }

      .in-cart-badge {
        display: inline-block;
        background: #10b981;
        color: white;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 600;
        margin-left: 8px;
      }

      .no-products-message {
        text-align: center;
        padding: 40px 20px;
        color: #6b7280;
      }

      .loading-spinner {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 3px solid #e5e7eb;
        border-top-color: #06b6d4;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  async fetchCartItems() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Store cart items with their quantities
      this.cartItems = {};
      cart.items.forEach(item => {
        this.cartItems[item.product_id] = {
          variant_id: item.variant_id,
          quantity: item.quantity
        };
      });
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async hasLeaseProductInCart() {
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      if (!cart.items || cart.items.length === 0) {
        return false;
      }

      // Ensure products are loaded
      if (!this.allProducts.length) {
        await this.fetchAllProducts();
      }

      for (const item of cart.items) {
        const product = this.allProducts.find(p =>
          p.variants.some(v => v.id === item.variant_id)
        );

        if (!product) continue;

        //check with product type
        if (product.product_type && product.product_type.toLowerCase() === 'leasing') {
          return true;
        }
        
      }

      return false;
    } catch (err) {
      console.error('Failed to check lease in cart', err);
      return false;
    }
  }

  interceptAddToCart() {
    console.log("Cart interception initialized");

    // Also intercept AJAX add to cart (for themes using AJAX)
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/add')) {
        console.log("AJAX add to cart intercepted from ajax");

        try {
          const clonedResponse = response.clone();
          const data = await clonedResponse.json();

          console.log("AJAX add to cart data:", data);

          if (data.handle) {
            await this.fetchProductData(data.handle);
          }
        } catch (error) {
          console.error('Error processing AJAX add to cart:', error);
        }
      }

      return response;
    };

    // Intercept jQuery AJAX if present (for older themes)
    if (window.jQuery) {
      const originalAjax = jQuery.ajax;
      jQuery.ajax = function (options) {
        if (options.url && options.url.includes('/cart/add')) {
          console.log("jQuery AJAX add to cart intercepted");

          const originalSuccess = options.success;
          options.success = async function (data) {
            await window.addonsPopup.fetchProductData(data.handle);

            if (originalSuccess) {
              originalSuccess.apply(this, arguments);
            }
          };
        }
        return originalAjax.apply(this, arguments);
      };
    }
  }

  getProductTags(product) {
    return (product.tags || [])
      .map(t => t.toLowerCase().trim());
  }

  getAddonTagsFromProduct(product) {
    if (this.TAG_MAP[product.handle]) {
      return this.TAG_MAP[product.handle];
    }
    return [];
  }

  filterAddonProducts(allProducts, addonTags, currentProductId) {
    const normalizedAddonTags = addonTags.map(t => t.toLowerCase());
    return allProducts.filter(p => {
      if (p.id === currentProductId) return false;
      const tags = (p.tags || []).map(t => t.toLowerCase());
      return normalizedAddonTags.some(tag => tags.includes(tag));
    });
  }

  async removeProductFromCartByHandle(handle) {
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      const item = cart.items.find(i => i.handle === handle);
      if (!item) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    } catch (e) {
      console.error('Failed to remove product from cart', e);
    }
  }

  async fetchProductData(handle) {
    // Ensure products are loaded
    if (!this.allProducts.length) {
      await this.fetchAllProducts();
    }

    // Find product from allProducts (consistent schema)
    let product = this.allProducts.find(p => p.handle === handle);

    this.currentProduct = product;

    if (!window.location.href.includes("type=lease")) {
      // 🚫 BLOCK if lease already in cart
      const hasLease = await this.hasLeaseProductInCart();
      if (hasLease) {
        // 🧹 silently remove main product that was just added
        await this.removeProductFromCartByHandle(handle);

        alert(
          "You already have a lease product in your cart. Buy products must be purchased in a separate order."
        );
        window.location.reload();
        return;
      }
    }

    const addonTags = this.getAddonTagsFromProduct(product);
    console.log("Addon tags for product:", addonTags);

    this.collectionProducts = this.filterAddonProducts(
      this.allProducts,
      addonTags,
      product.id
    );

    // if (this.collectionProducts && this.collectionProducts.length > 0) {
    //   console.log("Collection products:", this.collectionProducts);
    //   this.showPopup();
    // }
  }

  showPopup() {
    // Initialize quantities with main product
    const mainVariant = this.currentProduct.variants[0];
    console.log("Main variant:", mainVariant, this.currentProduct);

    const mainVariantId = mainVariant.id;

    this.quantities = {
      [mainVariantId]: 1
    };

    let image = null;
    if (this.currentProduct.featured_image) {
      image = this.currentProduct.featured_image;
    } else {
      if (this.currentProduct.images && this.currentProduct.images.length > 0) {
        image = this.currentProduct.images[0]["src"];
      }
    }

    // Create popup HTML
    const overlay = document.createElement('div');
    overlay.className = 'addons-overlay';
    overlay.innerHTML = `
      <div class="addons-popup">
        <div class="addons-header">
          <h2>Select Add-ons</h2>
          <button class="addons-close" onclick="this.closest('.addons-overlay').remove()">×</button>
        </div>
        
        <div class="addons-content">
          <div class="addons-section-header">
            <span>YOUR PRODUCT</span>
            <span>QUANTITY</span>
            <span>PRICE</span>
          </div>
          
          <div class="main-product-card">
            <div class="product-info">
              <img src="${image}" alt="${this.currentProduct.title}" class="product-image">
              <div class="product-details">
                <h4>${this.currentProduct.title}</h4>
                <p class="product-price">${this.formatMoney(mainVariant.price)}</p>
              </div>
            </div>
            
            <div class="quantity-controls">
              <button class="qty-btn" onclick="addonsPopup.updateQuantity('${mainVariantId}', -1)">−</button>
              <input type="text" class="qty-input" value="1" onchange="addonsPopup.setQuantity('${mainVariantId}', this.value)" data-product="${mainVariantId}">
              <button class="qty-btn" onclick="addonsPopup.updateQuantity('${mainVariantId}', 1)">+</button>
            </div>
            
            <div class="product-total" data-total="${mainVariantId}">
              ${this.formatMoney(mainVariant.price)}
            </div>
          </div>
          
          <h3 class="addons-title">Select Add-on Products</h3>
          
          <div class="addons-grid">
            ${this.renderAddonProducts()}
          </div>
        </div>
        
        <div class="addons-footer">
          <div class="footer-actions">
            <div class="total-section">
              <p>Items Total</p>
              <p class="total-amount" id="popup-total">${this.formatMoney(mainVariant.price)}</p>
            </div>
            
            <div class="action-buttons">
              <button class="btn btn-secondary" onclick="addonsPopup.addToCart()">ADD TO CART</button>
              <button class="btn btn-primary" onclick="addonsPopup.buyNow()">BUY NOW</button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    this.popup = overlay;
  }

  renderAddonProducts() {
    if (!this.collectionProducts || this.collectionProducts.length === 0) {
      return `
        <div class="no-products-message">
          <p>No related products available in this collection</p>
        </div>
      `;
    }

    return this.collectionProducts.map(product => {

      let image = null;
      if (product.featured_image) {
        image = product.featured_image;
      } else {
        if (product.images && product.images.length > 0) {
          image = product.images[0]["src"];
        }
      }

      let price = null;
      let variantId = null;

      for (const variant of product.variants) {
        if (!price || variant.title === "Buy") {
          price = variant.price;
          variantId = variant.id;
        }
      }

      const cartItem = this.cartItems[product.id];
      const isInCart = !!cartItem;
      const inCartBadge = isInCart ? '<span class="in-cart-badge">IN CART</span>' : '';

      const checkedClass = isInCart ? 'checked' : '';
      const selectedClass = isInCart ? 'selected' : '';
      const qtyValue = isInCart ? cartItem.quantity : 0;

      // preload quantity state
      if (isInCart && cartItem.variant_id && this.quantities[cartItem.variant_id] == null) {
        this.quantities[cartItem.variant_id] = cartItem.quantity;
      }

      return `
        <div class="addon-card ${selectedClass}" data-product="${variantId}">
          <div class="addon-checkbox ${checkedClass}" onclick="addonsPopup.toggleAddon('${variantId}', this)">
            <span style="display:${isInCart ? 'block' : 'none'};">✓</span>
          </div>
          
          <img src="${image}" alt="${product.title}" class="addon-image">
          
          <div class="addon-details">
            <h4 class="addon-name">${product.title}${inCartBadge}</h4>
            <p class="addon-price">${this.formatMoney(price)}</p>
          </div>
          
          <div class="addon-quantity">
            <button class="addon-qty-btn" onclick="addonsPopup.updateQuantity('${variantId}', -1)">−</button>
            <input type="text" class="addon-qty-input" value="${qtyValue}" onchange="addonsPopup.setQuantity('${variantId}', this.value)" data-product="${variantId}">
            <button class="addon-qty-btn" onclick="addonsPopup.updateQuantity('${variantId}', 1)">+</button>
          </div>
        </div>
      `;
    }).join('');
  }

  toggleAddon(variantId, checkbox) {
    const card = checkbox.closest('.addon-card');
    const checkmark = checkbox.querySelector('span');
    const input = card.querySelector('.addon-qty-input');

    if (this.quantities[variantId]) {
      delete this.quantities[variantId];
      card.classList.remove('selected');
      checkbox.classList.remove('checked');
      checkmark.style.display = 'none';
      input.value = '0';
    } else {
      this.quantities[variantId] = 1;
      card.classList.add('selected');
      checkbox.classList.add('checked');
      checkmark.style.display = 'block';
      input.value = '1';
    }

    this.updateTotal();
  }

  updateQuantity(variantId, delta) {
    const current = this.quantities[variantId] || 0;
    const newValue = Math.max(0, current + delta);

    if (newValue === 0) {
      delete this.quantities[variantId];

      const card = document.querySelector(`.addon-card[data-product="${variantId}"]`);
      if (card) {
        card.classList.remove('selected');

        const checkbox = card.querySelector('.addon-checkbox');
        if (checkbox) {
          checkbox.classList.remove('checked');
          checkbox.querySelector('span').style.display = 'none';
        }
      }
    } else {
      this.quantities[variantId] = newValue;

      const card = document.querySelector(`.addon-card[data-product="${variantId}"]`);
      if (card) {
        card.classList.add('selected');

        const checkbox = card.querySelector('.addon-checkbox');
        if (checkbox) {
          checkbox.classList.add('checked');
          checkbox.querySelector('span').style.display = 'block';
        }
      }
    }

    const input = document.querySelector(`input[data-product="${variantId}"]`);
    if (input) input.value = newValue;

    this.updateTotal();
  }

  setQuantity(variantId, value) {
    const qty = Math.max(0, parseInt(value) || 0);

    if (qty === 0) {
      delete this.quantities[variantId];

      const card = document.querySelector(`.addon-card[data-product="${variantId}"]`);
      if (card) {
        card.classList.remove('selected');

        const checkbox = card.querySelector('.addon-checkbox');
        if (checkbox) {
          checkbox.classList.remove('checked');
          checkbox.querySelector('span').style.display = 'none';
        }
      }
    } else {
      this.quantities[variantId] = qty;

      const card = document.querySelector(`.addon-card[data-product="${variantId}"]`);
      if (card) {
        card.classList.add('selected');

        const checkbox = card.querySelector('.addon-checkbox');
        if (checkbox) {
          checkbox.classList.add('checked');
          checkbox.querySelector('span').style.display = 'block';
        }
      }
    }

    this.updateTotal();
  }

  updateTotal() {
    let total = 0;

    // Main product
    const mainVariant = this.currentProduct.variants[0];
    const mainQty = this.quantities[mainVariant.id] || 0;
    const mainTotal = mainVariant.price * mainQty;
    total += mainTotal;

    const mainVariantId = this.currentProduct.variants[0].id;
    const mainTotalEl = document.querySelector(
      `[data-total="${mainVariantId}"]`
    );
    if (mainTotalEl) {
      mainTotalEl.textContent = this.formatMoney(mainTotal);
    }

    // Add-ons
    this.collectionProducts.forEach(product => {
      product.variants.forEach(variant => {
        const qty = this.quantities[variant.id];
        if (qty) {
          total += variant.price * qty;
        }
      });
    });

    document.getElementById('popup-total').textContent =
      this.formatMoney(total);
  }

  async addToCart(redirect = true) {
    const items = this.prepareCartItems();

    const mainVariant = this.currentProduct.variants[0];
    const mainVariantId = String(mainVariant.id);

    const desiredQty = this.quantities[mainVariantId] || 1;

    if (items.length === 0) {
      alert('Please select at least one product');
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (response.ok) {

        //update main product quantity
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: mainVariantId,
            quantity: desiredQty
          })
        });

        // Close popup
        if (this.popup) {
          this.popup.remove();
        }
        if (redirect) {
          // Refresh cart or redirect
          window.location.replace("/cart");
        }
      } else {
        throw new Error('Failed to add items to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding products to cart. Please try again.');
    }
  }

  async buyNow() {
    await this.addToCart(false);
    setTimeout(() => {
      window.location.href = '/checkout';
    }, 500);
  }

  prepareCartItems() {
    return Object.entries(this.quantities)
      .filter(([_, qty]) => qty > 0)
      .map(([variantId, qty]) => ({
        id: Number(variantId),
        quantity: qty
      }));
  }

  formatMoney(dollars) {
    // Format based on Shopify's currency format
    const amount = (dollars * 1).toFixed(2);
    return `${amount} ${window.Shopify.currency.active}`;
  }
}

window.addonsPopup = new ShopifyAddonsPopup();